import { faPenToSquare, faTrashCan } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, IconButton, IconButtonProps, styled } from "@mui/material";
import { Link } from "react-router-dom";
import { FC } from "react";

export const StyledButton = styled(Button) (({theme}) => ({
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.light
}));

export const StyledIconButton = styled(IconButton) (({theme}) => ({
    display: "inline-flex",
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.light,
    ":hover": {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary.light,
    }
}))

interface IActionButtonProps extends IconButtonProps {
    variant: "edit" | "delete";
    to: string;
}

export const StyledActionButton:FC<IActionButtonProps> = (props) => {
    return (
        <StyledIconButton 
            {...props}
            //@ts-expect-error
            component={Link}
            size="small"
            state={{
                back: true
            }}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <FontAwesomeIcon icon={props.variant === "edit" ? faPenToSquare : faTrashCan} />
        </StyledIconButton>
    )
}